import React, { useState } from "react";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";
import ContactModal from "./ContactModal";

export default function HeroSection() {
  const [isContactOpen, setIsContactOpen] = useState(false);

  return (
    <>
      <section className="hero-section min-h-screen flex items-center justify-center relative overflow-hidden bg-gradient-to-b from-white via-gray-50/30 to-white">
        {/* Subtle background decoration */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-gray-100 rounded-full blur-3xl opacity-30 animate-float"></div>
          <div className="absolute bottom-1/4 left-1/4 w-80 h-80 bg-gray-100 rounded-full blur-3xl opacity-20 animate-float-delayed"></div>
        </div>

        <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-12 text-center relative z-10 py-24 sm:py-28 lg:py-32">
          <div className="mb-8 flex items-center justify-center animate-fade-in">
          </div>

          <h1 className="text-[2.6rem] sm:text-5xl lg:text-7xl font-light tracking-tight text-gray-900 mb-5 sm:mb-6 leading-[1.08] sm:leading-tight animate-fade-in-up">
            From classrooms to boardrooms
            <br />
            <span className="text-gray-500">AI that works where you do</span>
          </h1>

          <p className="text-base sm:text-lg lg:text-xl text-gray-600 font-light max-w-3xl mx-auto mb-10 sm:mb-12 leading-relaxed animate-fade-in-up-delayed">
            A suite of AI-powered products for teams, businesses, and educators built to improve how you create, collaborate, and communicate.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up-delayed-more">
            <Button
              size="lg"
              className="bg-gray-900 hover:bg-gray-800 text-white w-full max-w-[336px] sm:w-auto sm:max-w-none px-8 sm:px-10 py-5 sm:py-6 text-base font-normal rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-xl group"
              onClick={() => setIsContactOpen(true)}
            >
              Contact Us
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
            </Button>
            <a href="#products" className="w-full max-w-[336px] sm:w-auto sm:max-w-none">
              <Button
                size="lg"
                variant="outline"
                className="border-gray-200 hover:border-gray-900 hover:bg-gray-900 hover:text-white w-full px-8 sm:px-10 py-5 sm:py-6 text-base font-normal rounded-lg transition-all duration-300"
              >
                Explore Products
              </Button>
            </a>
          </div>
        </div>

        <style jsx>{`
          @keyframes float {
            0%, 100% { transform: translate(0, 0) scale(1); }
            50% { transform: translate(30px, -30px) scale(1.1); }
          }
          @keyframes float-delayed {
            0%, 100% { transform: translate(0, 0) scale(1); }
            50% { transform: translate(-30px, 30px) scale(1.1); }
          }
          .animate-float { animation: float 20s ease-in-out infinite; }
          .animate-float-delayed { animation: float-delayed 25s ease-in-out infinite; }
          .animate-fade-in { animation: fade-in 1s ease-out 0.2s both; }
          .animate-fade-in-up { animation: fade-in-up 1s ease-out 0.4s both; }
          .animate-fade-in-up-delayed { animation: fade-in-up 1s ease-out 0.6s both; }
          .animate-fade-in-up-delayed-more { animation: fade-in-up 1s ease-out 0.8s both; }
        `}</style>
      </section>

      <ContactModal 
        isOpen={isContactOpen} 
        onClose={() => setIsContactOpen(false)}
        defaultDemo={true}
      />
    </>
  );
}
